import React, {useEffect, useRef, useState} from 'react';
import './index.scss';
import {useDispatch, useSelector} from 'react-redux';
import {setFields} from '../../store/builder/reducer';
import Tooltip from '../Tooltip/index';

const normalize = val => {
  const s = String(val ?? '');
  return s.startsWith('.') ? '0' + s : s;
};

export default function Input({
  type = 'text',
  placeholder = '',
  name,
  id,
  image = '',
  maxwidth,
  label,
  onChange,
  onInput,
  defaultValue,
  value,
  required,
  minLength,
  disabled,
  readOnly,
  innerRef,
  keyProp,
  tooltip = false,
  tooltipText,
  containerWidth,
  bg,
  customStyles = {},
  titleStyles = {},
  inputStyles = {},
  title,
}) {
  const isNumber = type === 'number';

  // Display value for number inputs — shows what the user typed (.5),
  // while the normalized value (0.5) is sent upstream via onChange.
  const [displayValue, setDisplayValue] = useState(
    isNumber && value !== undefined && value !== null ? String(value) : '',
  );
  // Tracks the last normalized value we dispatched so we can tell the
  // difference between an external update and our own Redux round-trip.
  const lastNormalizedRef = useRef(
    isNumber && value !== undefined && value !== null ? normalize(value) : '',
  );

  useEffect(() => {
    if (!isNumber) return;
    const external = value !== undefined && value !== null ? String(value) : '';
    // Skip the round-trip: if the external value equals what we sent up,
    // keep showing the user's raw input instead of overwriting it.
    if (external !== lastNormalizedRef.current) {
      setDisplayValue(external);
      lastNormalizedRef.current = external;
    }
  }, [value, isNumber]);

  const handleNumberChange = e => {
    const raw = e.target.value;
    setDisplayValue(raw);
    const normed = normalize(raw);
    lastNormalizedRef.current = normed;
    if (onChange) onChange({target: {name, value: normed}});
  };

  const numberInputOnWheelPreventChange = e => {
    e.target.blur();
    e.stopPropagation();
    setTimeout(() => {
      e.target.focus();
    }, 0);
  };

  return (
    <label
      className={`customInput ${image ? 'search' : ''} ${bg === 'white' ? 'new' : ''} ${readOnly ? 'disabled' : ''}`}
      htmlFor={name}
      title={title}
      style={{width: containerWidth, ...customStyles}}
    >
      {label && (
        <div style={{display: 'flex', alignItems: 'center'}}>
        {label && <span style={{...titleStyles}}>{label}</span>}
        {tooltip && <Tooltip tooltipText={tooltipText} />}
      </div>
      )}

      {image && (
        <img className='customInput__search' src={image} alt='search' />
      )}
      {value !== undefined && value !== null ? (
        <input
          ref={innerRef}
          style={{
            width: maxwidth,
            color: disabled && '#999999',
            ...inputStyles,
          }}
          type={type}
          name={name}
          id={id}
          key={keyProp}
          placeholder={placeholder}
          onChange={isNumber ? handleNumberChange : onChange}
          onInput={onInput && onInput}
          value={isNumber ? displayValue : value}
          required={required}
          maxLength={190}
          minLength={minLength}
          autoComplete='off'
          disabled={readOnly ? true : disabled ? true : false}
          onWheel={isNumber ? numberInputOnWheelPreventChange : null}
        />
      ) : (
        <input
          ref={innerRef}
          style={{
            width: maxwidth,
            color: readOnly && '#999999',
            backgroundColor: !readOnly && '#ffffff',
            ...inputStyles,
          }}
          type={type}
          name={name}
          id={id}
          key={keyProp}
          placeholder={placeholder}
          onChange={onChange}
          onInput={onInput && onInput}
          defaultValue={defaultValue}
          required={required}
          maxLength={190}
          minLength={minLength}
          autoComplete='off'
          disabled={readOnly ? true : disabled ? true : false}
          onWheel={isNumber ? numberInputOnWheelPreventChange : null}
        />
      )}
    </label>
  );
}
